import { render, staticRenderFns } from "./learningstatistics.vue?vue&type=template&id=39c2c0c0"
import script from "./learningstatistics.vue?vue&type=script&lang=js"
export * from "./learningstatistics.vue?vue&type=script&lang=js"
import style0 from "./learningstatistics.vue?vue&type=style&index=0&id=39c2c0c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports